import { render, staticRenderFns } from "./MailBuilder.vue?vue&type=template&id=3bf4a3bf"
import script from "./MailBuilder.vue?vue&type=script&lang=js"
export * from "./MailBuilder.vue?vue&type=script&lang=js"
import style0 from "formiojs/dist/formio.full.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./MailBuilder.vue?vue&type=style&index=1&id=3bf4a3bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports